import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll all potentially scrollable containers
    const containers = [
      '.view-container-desktop',
      '.view-container-mobile',
      '.top-level-container-desktop',
      '.scrollBox'
    ];
    
    containers.forEach(selector => {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollTo({ top: 0, behavior: 'auto' });
      }
    });
    
    // Also scroll window
    window.scrollTo({ top: 0, behavior: 'auto' });
    
  }, [pathname]);

  return null;
}